export const enum TabType {
  PRODUCT_DETAIL_INFO = 0,
  SIZE_INFO = 1,
  REVIEW = 2,
  RECOMMEND = 3,
  CONTACT = 4,
}

export const PAGE_ID: Record<TabType, string> = {
  [TabType.PRODUCT_DETAIL_INFO]: 'detail',
  [TabType.SIZE_INFO]: 'size',
  [TabType.REVIEW]: 'review',
  [TabType.RECOMMEND]: 'recommendation',
  [TabType.CONTACT]: 'inquiry',
} as const;

export const ZigzinProductFreeShippingAmount = 55000;

export const ADD_TO_CART_COUNT_SESSION_DATA_KEY = 'add_to_cart_count';

export const MinimumOrderQuantityType = {
  PRODUCT: 'PRODUCT',
  ITEM: 'ITEM',
};
